<div class="d-flex flex-column align-items-center">
  <div [formGroup]="amountFormGroup" class="donation-amounts-container">
    <ng-container *ngFor="let donationAmount of constants.DONATION_AMOUNTS_VALUES; let i = index">
      <ns-button (callback$)="onFixedAmountClick(donationAmount)"
                 [brandColor]="brandColor"
                 [classes]="brandColor ? 'branded-donation-amount-btn': 'donation-amount-btn'"
                 [isActive]="donationAmount === activeButtonKey"
                 [text]="constants.DONATION_AMOUNTS_TEXTS[i]">
      </ns-button>
    </ng-container>
  </div>
  <form [formGroup]="amountFormGroup">
    <ns-number-input
      (callback$)="onFreeAmountType($event)"
      (errorMessageKey$)="onErrorMessageKey($event)"
      [$reset]="resetNumberField$"
      [allowDecimals]="false"
      [brandColor]="brandColor"
      [classes]="brandColor ? 'branded-donation-amount-input': 'donation-amount-input'"
      [control]="amountInput"
      [customPlaceholder]="donationInputPlaceholder"
      [leftIcon]="'€'"
      [maxLength]="6"
      [maxValue]="constants.MAXIMUM_DONATION_AMOUNT"
      [minValue]="constants.MINIMUM_DONATION_AMOUNT"
    >
    </ns-number-input>
  </form>
  <span [ngClass]="{'invisible': !showContactUs}"
        class="donation-exceeded-error">{{'DONATION_SELECTOR.donation_exceeded_error' | translate}}
    <a
      [href]="'mailto:' + constants.HELLO_NOOS_EMAIL">{{'DONATION_SELECTOR.donation_exceeded_error_link' | translate}}</a>.
  </span>
</div>
